export default "__VITE_ASSET__NBF6aNhd__"